import { render } from "./FavoritePage.vue?vue&type=template&id=29b6a601"
import script from "./FavoritePage.vue?vue&type=script&lang=js"
export * from "./FavoritePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__